module.exports = __webpack_public_path__ + "img/title-01.9d1e2a07.png";